import type { EventId } from '../types/envelope.js';

const UUID_V7_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function parseEventId(value: unknown): EventId {
  if (typeof value !== 'string') {
    throw new Error('Invalid EventId: must be a string');
  }

  if (!UUID_V7_REGEX.test(value)) {
    throw new Error(
      'Invalid EventId: must be a valid UUIDv7'
    );
  }

  return value.toLowerCase() as EventId;
}

export function isEventId(value: unknown): value is EventId {
  try {
    parseEventId(value);
    return true;
  } catch {
    return false;
  }
}
